<div class="bar">
  <div class="group left">
    <ng-content select="[left]" />
    @if (formModeService.isShowMode() && reRoute()) {
      <button
        procure-button
        variant="stroked"
        matTooltipClass="line-breaks-tooltip"
        [matTooltip]="reRoute()?.tooltip ?? ''"
        [routerLink]="[reRoute()?.route]"
      >
        {{ reRoute()?.prompt }}
      </button>
    }
    @if (formModeService.isShowMode() && canDelete()) {
      <button
        procure-button
        variant="stroked"
        [matTooltip]="`Permanently delete ${entityService.getEntityTypeLabel()}`"
        [disabled]="isPerformingAction()"
        [loading]="isDeleting()"
        [attr.data-testid]="TestIds.Delete"
        (click)="onDelete()"
      >
        <mat-icon> delete </mat-icon>
      </button>
    }
  </div>
  <div class="group right">
    <ng-content select="[right]" />
    @if (!hideMutateActions()) {
      @if (formModeService.isShowMode()) {
        @if (availableStatusTransitions().length && entityType()) {
          <mat-icon
            class="workflow"
            (click)="showWorkflowDialog()"
          >
            info
          </mat-icon>
        }
        @for (transition of availableStatusTransitions() | filter: "isDirect" : true; track transition.id) {
          <button
            procure-button
            variant="stroked"
            matTooltipClass="line-breaks-tooltip"
            [matTooltip]="transition.description ?? ''"
            [disabled]="isPerformingAction()"
            [loading]="isSaving()"
            (click)="transitionStatus.emit(transition.id)"
          >
            <div class="status">
              <div [class]="`status-icon ${transition.color}`"></div>
              {{ transition.name }}
            </div>
          </button>
        }
        @if ((availableStatusTransitions() | filter: "isDirect" : false).length) {
          <button
            procure-button
            variant="stroked"
            suffix="arrow_drop_down"
            [matMenuTriggerFor]="statusMenu"
            [disabled]="isPerformingAction()"
            [loading]="isSaving()"
          >
            Status
          </button>
        }
        <mat-menu #statusMenu>
          @for (transition of availableStatusTransitions() | filter: "isDirect" : false; track transition.id) {
            <button
              mat-menu-item
              matTooltipClass="line-breaks-tooltip"
              [matTooltip]="transition.description ?? ''"
              (click)="transitionStatus.emit(transition.id)"
            >
              <div class="status">
                <div [class]="`status-icon ${transition.color}`"></div>
                {{ transition.name }}
              </div>
            </button>
          }
        </mat-menu>
        @if (canReview()) {
          <button
            procure-button
            [disabled]="isPerformingAction()"
            (click)="onReview()"
          >
            Review
          </button>
        }
        @if (canEdit()) {
          @if (!allowComplexEdit()) {
            <button
              procure-button
              [disabled]="isPerformingAction()"
              [attr.data-testid]="TestIds.Edit"
              (click)="onEdit()"
            >
              Edit
            </button>
          } @else {
            <procure-button-group>
              <button
                procure-button
                variant="flat"
                [disabled]="isPerformingAction()"
                (click)="onEdit()"
              >
                Edit
              </button>
              <button
                procure-button
                variant="flat"
                [disabled]="isPerformingAction()"
                [matMenuTriggerFor]="editMenu"
              >
                <mat-icon>arrow_drop_down</mat-icon>
              </button>
            </procure-button-group>
          }
          <mat-menu #editMenu="matMenu">
            <button
              mat-menu-item
              [disabled]="isPerformingAction()"
              (click)="onEdit()"
            >
              Edit
            </button>
            <button
              mat-menu-item
              matTooltip="Edit RFQ including information, requirements, and cost breakdown structure"
              [disabled]="isPerformingAction()"
              (click)="onEditComplex()"
            >
              Edit All
            </button>
          </mat-menu>
        }
      } @else {
        <button
          procure-button
          variant="stroked"
          [disabled]="isPerformingAction()"
          [attr.data-testid]="TestIds.Cancel"
          (click)="onCancel()"
        >
          Cancel
        </button>
        @if (canReview() && formModeService.isReviewMode()) {
          <button
            procure-button
            color="primary"
            [disabled]="
              isTogglingFavorite() || (!canReview() && !formModeService.isReviewMode()) || fileUploadsPending()
            "
            [loading]="isSaving() || fileUploadsPending()"
            [matTooltip]="reviewInvalid() ? 'The form contains validation errors.' : ''"
            [suffix]="reviewInvalid() ? 'warning' : ''"
            (click)="onFinishReview()"
          >
            Finish Review
          </button>
        }
        @if (!formModeService.isReviewMode() && !saveAsDraft()) {
          @if (!allowSaveWithoutNotifying()) {
            <button
              procure-button
              color="primary"
              [disabled]="isTogglingFavorite() || (!canSave() && !formModeService.isAddMode()) || fileUploadsPending()"
              [loading]="isSaving() || fileUploadsPending()"
              [matTooltip]="invalid() ? 'The form contains validation errors.' : ''"
              [suffix]="invalid() ? 'warning' : ''"
              [attr.data-testid]="TestIds.Save"
              (click)="onSave(true)"
            >
              Save
            </button>
          } @else {
            <procure-button-group>
              <button
                procure-button
                variant="flat"
                color="primary"
                [disabled]="
                  isTogglingFavorite() || (!canSave() && !formModeService.isAddMode()) || fileUploadsPending()
                "
                [loading]="isSaving() || fileUploadsPending()"
                [matTooltip]="invalid() ? 'The form contains validation errors.' : ''"
                [suffix]="invalid() ? 'warning' : ''"
                (click)="onSave(true)"
              >
                Save
              </button>
              <button
                procure-button
                variant="flat"
                color="primary"
                [disabled]="
                  isTogglingFavorite() || (!canSave() && !formModeService.isAddMode()) || fileUploadsPending()
                "
                [loading]="isSaving() || fileUploadsPending()"
                [matMenuTriggerFor]="saveMenu"
              >
                <mat-icon>arrow_drop_down</mat-icon>
              </button>
            </procure-button-group>
          }
        }
        <mat-menu #saveMenu="matMenu">
          <button
            mat-menu-item
            [disabled]="invalid() || isPerformingAction()"
            (click)="onSave(true)"
          >
            Save
          </button>
          <button
            mat-menu-item
            [disabled]="invalid() || isSaving() || isTogglingFavorite()"
            (click)="onSave(false)"
          >
            Save without notifying
          </button>
        </mat-menu>
      }
      @if (saveAsDraft() && !formModeService.isShowMode()) {
        <procure-button-group>
          <button
            procure-button
            variant="flat"
            color="primary"
            [disabled]="isTogglingFavorite() || (!canSave() && !formModeService.isAddMode()) || fileUploadsPending()"
            [loading]="isSaving() || fileUploadsPending()"
            [matTooltip]="invalid() ? 'The form contains validation errors.' : ''"
            [suffix]="invalid() ? 'warning' : ''"
            (click)="onDraftSave(true)"
          >
            Save and Launch
          </button>
          <button
            procure-button
            variant="flat"
            color="primary"
            [disabled]="isTogglingFavorite() || (!canSave() && !formModeService.isAddMode()) || fileUploadsPending()"
            [loading]="isSaving() || fileUploadsPending()"
            [matMenuTriggerFor]="saveAsDraftMenu"
          >
            <mat-icon>arrow_drop_down</mat-icon>
          </button>
        </procure-button-group>
      }
      <mat-menu #saveAsDraftMenu="matMenu">
        <button
          mat-menu-item
          [disabled]="isTogglingFavorite() || (!canSave() && !formModeService.isAddMode()) || fileUploadsPending()"
          (click)="onDraftSave(true)"
        >
          Save and Launch
        </button>
        <button
          mat-menu-item
          [disabled]="isTogglingFavorite() || (!canSave() && !formModeService.isAddMode()) || fileUploadsPending()"
          (click)="onDraftSave(false)"
        >
          Save as Draft
        </button>
      </mat-menu>
    }
    @if (evaluation()) {
      <button
        procure-button
        color="primary"
        [loading]="isSaving()"
        [matTooltip]="invalid() ? 'The form contains validation errors.' : ''"
        [suffix]="invalid() ? 'warning' : ''"
        (click)="onSubmit()"
      >
        Submit
      </button>
    }
  </div>
</div>
